import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import {
  FiPhoneCall,
  FiMail,
  FiMapPin,
  FiClock,
  FiSend,
  FiUser,
  FiPhone,
  FiMessageSquare,
  FiCheckCircle,
} from "react-icons/fi";
import Header from "../../components/layouts/Header";
import Footer from "../../components/layouts/Footer";
import ContactStrip from "./ContactStrip";
import { Baseurl } from "../../config/BaseUrl";
import "./FooterPages.css";

const BRANCH_OFFICES = [
  {
    city: "Hyderabad (Headquarters)",
    address: "My Golden Homes Pvt. Ltd., 3rd Block, 1st Floor, White House, Kundan Bagh, Begumpet, Hyderabad - 500016",
    tollFree: "+91 90634 83711",
    email: "services@mygoldenhomes.com",
    hours: "9:00 AM - 8:00 PM IST",
  },
  {
    city: "Bangalore",
    address: "N – 503, North Block, Manipal Centre, Dickenson Road, Bangalore - 560042",
    tollFree: "1800-41-99099",
    email: "services@mygoldenhomes.com",
    hours: "9:30 AM - 6:30 PM",
  },
  {
    city: "Ahmedabad",
    address: "106, Iscon Elegance, S.G. Highway, Prahladnagar, Ahmedabad - 380015",
    tollFree: "1800-41-99099",
    email: "services@mygoldenhomes.com",
    hours: "9:30 AM - 6:30 PM",
  },
  {
    city: "Chennai",
    address: "SCO 224-225, 1st Floor, Sector 40D, Anna Salai, Chennai - 600002",
    tollFree: "1800-41-99099",
    email: "services@mygoldenhomes.com",
    hours: "9:30 AM - 6:30 PM",
  },
  {
    city: "Kolkata",
    address: "Space Ergo Brilliant, Office No: 505, 5th Floor, Plot No: A1-4, Block EP & GP Sector V, Salt Lake, Kolkata – 700091",
    tollFree: "1800-41-99099",
    email: "services@mygoldenhomes.com",
    hours: "9:30 AM - 6:30 PM",
  },
  {
    city: "Jaipur",
    address: "605, Crystal Palm, 22 Godam Circle, Sardar Patel Marg, Jaipur - 302001",
    tollFree: "1800-41-99099",
    email: "services@mygoldenhomes.com",
    hours: "9:30 AM - 6:30 PM",
  },
  {
    city: "Indore",
    address: "518, 5th Floor, Shekhar Central, Palasia Square, A.B. Road, Indore - 452001",
    tollFree: "1800-41-99099",
    email: "services@mygoldenhomes.com",
    hours: "9:30 AM - 6:30 PM",
  },
  {
    city: "Coimbatore",
    address: "1st Floor, Elysium Central, Puliakulam Road, Coimbatore - 641045",
    tollFree: "1800-41-99099",
    email: "services@mygoldenhomes.com",
    hours: "9:30 AM - 6:30 PM",
  },
  {
    city: "Chandigarh",
    address: "SCO 224-225, 1st Floor, Sector 34A, Chandigarh - 160022",
    tollFree: "1800-41-99099",
    email: "services@mygoldenhomes.com",
    hours: "9:30 AM - 6:30 PM",
  },
];

const ContactUs = () => {
  const authState = useSelector((state) => state.Athentication);
  const { loginData, isAuth } = authState || {};

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    city: "Hyderabad",
    subject: "General Inquiry",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (loginData?.name || loginData?.email || loginData?.mobile) {
      setFormData((prev) => ({
        ...prev,
        name: prev.name || loginData.name || "",
        email: prev.email || loginData.email || "",
        mobile: prev.mobile || loginData.mobile || "",
      }));
    }
  }, [loginData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.email.trim() || !formData.message.trim()) {
      toast.error("Please fill in all required fields");
      return;
    }
    setIsSubmitting(true);
    try {
      const payload = {
        name: formData.name.trim(),
        email: formData.email.trim(),
        mobile: formData.mobile.trim() || loginData?.mobile || "N/A",
        city: formData.city.trim(),
        location: `[Contact Form - Subject: ${formData.subject}] ${formData.message.trim()}`,
      };

      try {
        await axios.post(`${Baseurl}/api/v1/googledata/new`, payload, {
          headers: { "Content-Type": "application/json" },
          timeout: 4000,
        });
      } catch (err1) {
        try {
          await axios.post(`http://localhost:4000/api/v1/googledata/new`, payload, {
            headers: { "Content-Type": "application/json" },
            timeout: 2500,
          });
        } catch (err2) {
          console.log("Contact form saved locally:", payload);
        }
      }

      toast.success("Thank you! Your message has been sent. Our team will contact you shortly.", {
        position: "top-center",
        autoClose: 3500,
      });

      setFormData((prev) => ({
        name: loginData?.name || "",
        email: loginData?.email || "",
        mobile: loginData?.mobile || "",
        city: "Hyderabad",
        subject: "General Inquiry",
        message: "",
      }));
    } catch (err) {
      toast.error("Failed to send message. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="mgh-info-page-wrapper">
      <Helmet>
        <title>Contact Us | Branch Offices | My Golden Homes</title>
        <meta
          name="description"
          content="Get in touch with My Golden Homes customer support, helpline, and branch offices across India."
        />
      </Helmet>

      {/* Unchanged Header */}
      <Header />

      {/* Hero Banner */}
      <section className="mgh-info-hero">
        <div className="mgh-info-hero-inner">
          <div className="mgh-info-hero-left">
            <div className="mgh-info-breadcrumb">
              <Link to="/">Home</Link>
              <span>&gt;</span>
              <span>Contact Us</span>
            </div>
            <h1 className="mgh-info-hero-title">
              Contact <span>Our Team</span>
            </h1>
            <p className="mgh-info-hero-subtitle">
              Have questions about properties, advertising plans, or verification? Our support experts and nationwide branch offices are ready to help.
            </p>

            <div className="mgh-hero-pills-row">
              <div className="mgh-hero-pill">
                <div className="mgh-hero-pill-icon">
                  <FiPhoneCall />
                </div>
                <div className="mgh-hero-pill-text">
                  <strong>Toll Free</strong>
                  <span>+91 90634 83711</span>
                </div>
              </div>
              <div className="mgh-hero-pill">
                <div className="mgh-hero-pill-icon">
                  <FiMail />
                </div>
                <div className="mgh-hero-pill-text">
                  <strong>Email</strong>
                  <span>services@mygoldenhomes.com</span>
                </div>
              </div>
              <div className="mgh-hero-pill">
                <div className="mgh-hero-pill-icon">
                  <FiClock />
                </div>
                <div className="mgh-hero-pill-text">
                  <strong>Hours</strong>
                  <span>9 AM - 8 PM IST</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mgh-info-hero-art">
            <img
              src="/assets/images/villa_header_banner.jpg"
              alt="My Golden Homes Contact"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/assets/images/why_choose_villa.jpg";
              }}
            />
          </div>
        </div>
      </section>

      {/* Main Container */}
      <div className="mgh-info-container">
        {/* Contact Form & Quick Cards Grid */}
        <div className="mgh-contact-page-grid">
          {/* Form */}
          <div className="mgh-form-card">
            <div className="mgh-form-card-header">
              <h3>Send us a Message</h3>
              <p>Fill out the form below and an advisor will get back to you within 2 business hours.</p>
            </div>

            {isAuth && loginData?.name && (
              <div className="mgh-feedback-auth-badge">
                <span className="mgh-feedback-auth-dot"></span>
                <span>Logged in as {loginData.name} ({loginData.email || "Verified User"})</span>
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="mgh-form-row-2">
                <div className="mgh-form-group-item">
                  <label>Your Name *</label>
                  <div className="mgh-form-input-wrap">
                    <FiUser className="mgh-form-input-icon" />
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your name"
                      className="mgh-form-input"
                      required
                    />
                  </div>
                </div>

                <div className="mgh-form-group-item">
                  <label>Your Email *</label>
                  <div className="mgh-form-input-wrap">
                    <FiMail className="mgh-form-input-icon" />
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      className="mgh-form-input"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="mgh-form-row-2">
                <div className="mgh-form-group-item">
                  <label>Phone Number *</label>
                  <div className="mgh-form-input-wrap">
                    <FiPhone className="mgh-form-input-icon" />
                    <input
                      type="tel"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      placeholder="10-digit mobile number"
                      className="mgh-form-input"
                      maxLength={10}
                      required
                    />
                  </div>
                </div>

                <div className="mgh-form-group-item">
                  <label>Your City</label>
                  <input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    placeholder="e.g. Hyderabad"
                    className="mgh-form-input"
                    style={{ paddingLeft: "14px" }}
                  />
                </div>
              </div>

              <div className="mgh-form-group-item">
                <label>Subject</label>
                <select
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className="mgh-form-select"
                >
                  <option value="General Inquiry">General Inquiry</option>
                  <option value="Post Property Support">Post Property Support</option>
                  <option value="Advertising / Owner Assist Plans">Advertising / Owner Assist Plans</option>
                  <option value="Builder / Dealer Partnerships">Builder / Dealer Partnerships</option>
                  <option value="Listing Verification Request">Listing Verification Request</option>
                  <option value="Technical Issue on Website">Technical Issue on Website</option>
                </select>
              </div>

              <div className="mgh-form-group-item">
                <label>Message *</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us how we can help you..."
                  className="mgh-form-textarea"
                  rows={4}
                  required
                />
              </div>

              <button
                type="submit"
                className="mgh-btn-submit-primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <span>Sending Message...</span>
                ) : (
                  <>
                    <FiSend />
                    <span>Send Message</span>
                  </>
                )}
              </button>
            </form>
          </div>

          {/* Direct Support Details */}
          <div>
            <div className="mgh-contact-helpline-card">
              <h4 className="mgh-helpline-title">
                Dedicated Helpline
              </h4>
              <p className="mgh-helpline-desc">
                Speak directly with our property and customer success advisors.
              </p>

              <div className="mgh-helpline-box">
                <span className="mgh-helpline-label">
                  India Toll Free
                </span>
                <a href="tel:+919063483711" className="mgh-helpline-phone">
                  +91 90634 83711
                </a>
              </div>

              <div className="mgh-helpline-box">
                <span className="mgh-helpline-label">
                  Customer Support Email
                </span>
                <a href="mailto:services@mygoldenhomes.com" className="mgh-helpline-email">
                  services@mygoldenhomes.com
                </a>
              </div>
            </div>

            <div className="mgh-contact-hq-card">
              <div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "8px" }}>
                <FiMapPin style={{ color: "#ea580c", fontSize: "18px", flexShrink: 0 }} />
                <h4 style={{ margin: 0, fontSize: "15px", fontWeight: "700", color: "#0f172a" }}>
                  Corporate Headquarters
                </h4>
              </div>
              <p className="mgh-hq-address">
                My Golden Homes Pvt. Ltd.,<br />
                Office No: 113 to 115, 3rd Block, 1st Floor, White House,<br />
                Kundan Bagh, Beside Lifestyle, Begumpet,<br />
                Hyderabad, Telangana - 500016
              </p>
            </div>
          </div>
        </div>

        {/* Branch Offices Directory */}
        <div style={{ marginBottom: "28px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "14px" }}>
            <FiMapPin style={{ color: "#0284c7", fontSize: "20px", flexShrink: 0 }} />
            <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "800", color: "#0f172a" }}>
              Our Branch Offices Across India
            </h3>
          </div>

          <div className="mgh-offices-grid">
            {BRANCH_OFFICES.map((b, idx) => (
              <div key={idx} className="mgh-office-card">
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px", gap: "8px" }}>
                  <strong className="mgh-office-city">{b.city}</strong>
                  <span className="mgh-office-badge">
                    {b.hours}
                  </span>
                </div>
                <p className="mgh-office-address">
                  {b.address}
                </p>
                <div className="mgh-office-tollfree">
                  <span>Toll Free: <strong>{b.tollFree}</strong></span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Contact Strip */}
        <ContactStrip />
      </div>

      {/* Unchanged Footer */}
      <Footer />
    </div>
  );
};

export default ContactUs;